export default {
  ratePlanType: {
    STANDARD: 'Standaard',
    BAR: 'Beste beschikbare tarief',
    CORPORATE: 'Zakelijk',
    MEMBER: 'Lid',
    PACKAGE: 'Pakket',
    PROMOTIONAL: 'Promotioneel',
    OTA: 'OTA',
    WHOLESALE: 'Groothandel',
    NEGOTIATED: 'Onderhandeld',
    MIXED: 'Gecombineerd tarief',
  },
} as const;
